export const GET_USER_PERMISSIONS = "GET_USER_PERMISSIONS";
